import Stack from '@mui/material/Stack';
import { useEffect, useState } from 'react';

export const NavigationBackground = ({ isBackgroundVisible }: { isBackgroundVisible: boolean }) => {
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    if (isBackgroundVisible) setIsHidden(false);
  }, [isBackgroundVisible]);

  return isHidden ? null : (
    <Stack
      sx={{
        background: { xs: 'rgba(255, 255, 255, 0.90);', lg: 'rgba(234, 236, 240, 0.85)' },
        backdropFilter: 'blur(20px)',
        height: '100vh',
        position: 'relative',
        zIndex: 1000,
      }}
      direction="column"
      alignItems="center"
      justifyContent="center"
      className={isBackgroundVisible ? 'wrapper-visible' : 'wrapper-hidden'}
      onAnimationEnd={(event) => {
        if (event.animationName === 'kioskWrapperFadeOut') setIsHidden(true);
      }}
    />
  );
};
